interface Session {
  day: string;
  focus: string;
  duration: string;
  type: 'practice' | 'review' | 'mock' | 'rest';
  domain?: string;
}

interface WeeklyScheduleProps {
  sessions: Session[];
}

const TYPE_CONFIG = {
  practice: { color: 'bg-emerald-100 text-emerald-700 border-emerald-200', icon: 'ri-pencil-line', dot: 'bg-emerald-500' },
  review: { color: 'bg-amber-100 text-amber-700 border-amber-200', icon: 'ri-book-open-line', dot: 'bg-amber-500' },
  mock: { color: 'bg-teal-100 text-teal-700 border-teal-200', icon: 'ri-timer-line', dot: 'bg-teal-500' },
  rest: { color: 'bg-gray-100 text-gray-500 border-gray-200', icon: 'ri-rest-time-line', dot: 'bg-gray-300' },
};

export default function WeeklySchedule({ sessions }: WeeklyScheduleProps) {
  return (
    <div className="bg-white rounded-2xl shadow-lg p-6">
      <h3 className="text-lg font-bold text-gray-900 mb-5 flex items-center gap-2">
        <div className="w-7 h-7 flex items-center justify-center">
          <i className="ri-calendar-2-line text-emerald-600 text-xl" />
        </div>
        Recommended Weekly Schedule
      </h3>
      <div className="grid grid-cols-7 gap-2">
        {sessions.map((session) => {
          const cfg = TYPE_CONFIG[session.type];
          return (
            <div key={session.day} className={`rounded-xl border p-3 text-center ${cfg.color}`}>
              <div className="text-xs font-black uppercase tracking-wider mb-2">{session.day}</div>
              <div className={`w-2 h-2 rounded-full ${cfg.dot} mx-auto mb-2`} />
              <div className="w-5 h-5 flex items-center justify-center mx-auto mb-1">
                <i className={`${cfg.icon} text-sm`} />
              </div>
              <p className="text-xs font-semibold leading-tight mb-1">{session.focus}</p>
              <p className="text-xs opacity-70">{session.duration}</p>
            </div>
          );
        })}
      </div>
      <div className="flex items-center gap-4 mt-4 pt-4 border-t border-gray-100 flex-wrap">
        {Object.entries(TYPE_CONFIG).map(([type, cfg]) => (
          <div key={type} className="flex items-center gap-1.5">
            <div className={`w-2.5 h-2.5 rounded-full ${cfg.dot}`} />
            <span className="text-xs text-gray-500 capitalize">{type}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
